<template>
  <footer class="footer" id="footer-ref">
    <a
      v-for="(link, i) in $tm('footer.links')"
      class="footer__link"
      :key="'footer-link-' + i"
      :href="link.link"
      target="__blank"
    >
      {{ link.label }}
    </a>
  </footer>
</template>

<script setup></script>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: center;
  background-color: $scala-grigi-white;
  position: relative;
  padding: 1.5rem;
  width: 100%;

  &__link {
    // @include btn-tertiary;
    @include link-m;
    text-transform: uppercase;
    opacity: 0.8;
    text-transform: uppercase;
    transition: opacity 0.3s ease;

    &:active {
      text-decoration: underline;
    }

    &:hover,
    &:active {
      opacity: 1;
    }

    padding: 0 1.5rem;

    &:not(:last-child) {
      border-right: 1px solid $scala-grigi-gray-3;
    }
  }

  .mobile & {
    flex-direction: column;
    align-items: center;
    padding: 1rem;

    &__link {
      padding: 1rem;
      position: relative;
      @include link-s;

      &:not(:last-child) {
        border: none;

        &::after {
          content: "";
          position: absolute;
          width: 2rem;
          height: 1px;
          background-color: $scala-grigi-gray-3;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
}
</style>
